import { request } from '@/utils/request';
import type { ApiResponse, WrappedResult } from './types';

const counterpartiesApi = {
  getAll(
    params?: cyrian.api.counterparties.GetParams,
  ): ApiResponse<WrappedResult<cyrian.api.counterparties.Counterparty[]>> {
    return request({
      method: 'get',
      url: '/counterparties',
      params,
    });
  },
  create(
    data: cyrian.api.counterparties.CounterpartyParams,
  ): ApiResponse<WrappedResult<cyrian.api.counterparties.Counterparty>> {
    return request({
      method: 'post',
      url: '/counterparties',
      data,
    });
  },
  update(
    id: number,
    data: cyrian.api.counterparties.CounterpartyParams,
  ): ApiResponse<WrappedResult<cyrian.api.counterparties.Counterparty>> {
    return request({
      method: 'patch',
      url: `/counterparties/${id}`,
      data,
    });
  },
  delete(id: number): ApiResponse<WrappedResult<any>> {
    return request({
      method: 'delete',
      url: `/counterparties/${id}`,
    });
  },
};

export default counterpartiesApi;
